import WsService from "services/WsService";
import S3DocumentMetaDataWithUrl from "../domain/Registration/S3DocumentMetaDataWithUrl";
import UserSessionService from "services/UserSessionService";
import BasicAuthGenerator from "utils/BasicAuthGenerator";
const ENDPOINT_BASE = "/s3-documents";

export default class S3DocumentUploadService {

    static getPresignedUrl(uploadRequest) {
        let endpoint = ENDPOINT_BASE + "/generate-upload-url";
        return WsService.post(endpoint, uploadRequest, 200).then(
            response => {
                // success
                return new S3DocumentMetaDataWithUrl(response);
            },
            response => {
                // fail
                return response;
            });

    }

    static insertS3MetaData(metaData) {

        let endpoint = ENDPOINT_BASE;
        let jsonObj = S3DocumentMetaDataWithUrl.toJson(metaData);
        return WsService.post(endpoint, jsonObj, 201).then(
            response => {
                return new S3DocumentMetaDataWithUrl(response);
            },
            response => {
                return response;
            });
    }

    static saveAndGetPresignedUrl(s3DocumentType, fileExtension) {
        let endpoint = ENDPOINT_BASE + "/save-and-generate-upload-url";
        let jsonObj = {
            "document-type": s3DocumentType,
            "file-type" : fileExtension
        };
        let headers = undefined;
        if(!UserSessionService.isAuthenticated()){
            let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
            headers = {
                "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"])
            };
        }
        return WsService.postWithHeaders(endpoint, jsonObj, 200, headers).then(
            response => {
                return new S3DocumentMetaDataWithUrl(response);
            },
            response => {
                return response;
            });
    }
}


